import { Stack, Typography } from '@mui/material'

import { useCardTypeBulkImportStore } from '@/components/BulkImportModal/hooks/useBulkImportStore'
import { checkTypeCardActivity } from '@/utils/checkTypeCard'
import { OptionSelectInput } from '@/components/InputFields/OptionSelectInput'

const OPTIONS_BULK_EDIT = {
  respond: [
    {
      label: 'Grading Method',
      value: 'grading_method',
    },
    {
      label: 'Feedback',
      value: 'feedback_types',
    },
    {
      label: 'Feedback Language',
      value: 'feedback_language',
    },
    {
      label: 'Points',
      value: 'points',
    },
    {
      label: 'Text to speech',
      value: 'allowTTS',
    },
    {
      label: 'Images',
      value: 'imageUrl',
    },
  ],
  repeat: [
    {
      label: 'Target Language',
      value: 'language',
    },
    {
      label: 'Points',
      value: 'points',
    },
    {
      label: 'Repeat times',
      value: 'repeat',
    },
    {
      label: 'Images',
      value: 'imageUrl',
    },
    {
      label: 'Leniency',
      value: 'difficulty',
    },
  ],
  mc: [
    {
      label: 'Points',
      value: 'points',
    },
    {
      label: 'Grading Method',
      value: 'MCQType',
    },
    {
      label: 'Images',
      value: 'imageUrl',
    },
  ],
  shortAnswer: [
    {
      label: 'Points',
      value: 'points',
    },
    {
      label: 'Images',
      value: 'imageUrl',
    },
    {
      label: 'Feedback Language',
      value: 'feedback_language',
    },
    {
      label: 'Correct Answer',
      value: 'correct_answer',
    },
  ],
}

export function BulkEditType({ field, setField }: { field: string; setField: (field: string) => void }) {
  const cardType = useCardTypeBulkImportStore()

  const { isRepeat, isMC, isShortAnswer } = checkTypeCardActivity(cardType)

  const options = isRepeat
    ? OPTIONS_BULK_EDIT.repeat
    : isMC
      ? OPTIONS_BULK_EDIT.mc
      : isShortAnswer
        ? OPTIONS_BULK_EDIT.shortAnswer
        : OPTIONS_BULK_EDIT.respond

  return (
    <Stack
      sx={{
        gap: '6px',
      }}
    >
      <Typography fontWeight="semibold">Which setting would you like to change?</Typography>
      <OptionSelectInput
        options={options}
        setValue={value => {
          setField(value)
        }}
        sx={{
          '& .MuiSelect-select': {
            paddingTop: '8px',
            paddingBottom: '8px',
          },
        }}
        value={field}
      />
    </Stack>
  )
}
